import CategoryList from "../views/CategoryList";
import CategorySubList from "../views/CategorySubList";

export default [
    {
        path: "/category-list",
        name: "CategoryList",
        component: CategoryList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/category-sub-list",
        name: "CategorySubList",
        component: CategorySubList,
        meta: {
            requiresAuth: true
        }
    },
];
